import { useMemo } from "react";

import { useWorkDesk } from "../../../../Workspace/components/hooks";

export function useClientCardIframeSyncOptions({
  mapPathnameForIframeSrc,
  mapPathnameFromChild,
  initialPathnameOverride,
  syncEnabled,
}) {
  const {
    isWorkdeskClientPath,
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
  } = useWorkDesk();

  const baseSyncOptions = useMemo(() => {
    const hasExplicitMapping = Boolean(
      mapPathnameForIframeSrc || mapPathnameFromChild
    );
    if (hasExplicitMapping) {
      return { mapPathnameForIframeSrc, mapPathnameFromChild };
    }
    if (isWorkdeskClientPath) {
      return {
        mapPathnameForIframeSrc: parentPathToIframePath,
        mapPathnameFromChild: iframePathToWorkdeskParentPath,
      };
    }
    return {};
  }, [
    mapPathnameForIframeSrc,
    mapPathnameFromChild,
    isWorkdeskClientPath,
    parentPathToIframePath,
    iframePathToWorkdeskParentPath,
  ]);

  return useMemo(() => {
    return {
      ...baseSyncOptions,
      ...(typeof initialPathnameOverride === "string"
        ? { initialPathnameOverride }
        : {}),
      ...(typeof syncEnabled === "boolean" ? { syncEnabled } : {}),
    };
  }, [baseSyncOptions, initialPathnameOverride, syncEnabled]);
}

export default useClientCardIframeSyncOptions;
